import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { SocialGroupData } from "../../../Data/Layout/Footer";
import { dynamicImage, Image } from "../../../Utils";
import FooterMenu from "./FooterMenu";
import { About } from "../../../Constants/Constants";
import { Route } from "../../../Routers/RouteList";
import { HeaderType } from "../../../Types/CommonComponentsType";
import { Fragment } from "react/jsx-runtime";

const Footer = ({ landing }: HeaderType) => {
  const SunTitle = "Contrary to popular belief, I would suggest you discuss this further with the advertising team.";
  return (
    <Fragment>
      <Container className="footer-main">
        <Row className="row footer-block">
          <Col lg="3" md="6" sm="12">
            <div className="footer-title footer-mobile-title">
              <h3>{About}</h3>
            </div>
            <div className="about-payment footer-contant1">
              <div className="logo">
                <Link to={Route.Messenger} target="_blank">
                  <Image className="for-light" src={dynamicImage("logo/landing-logo.png")} alt="logo" />
                  <Image className="for-dark" src={dynamicImage("logo/logo-white.png")} alt="logo" />
                </Link>
              </div>
              <p>{SunTitle}</p>
              <ul className="social-group">
                {SocialGroupData.map((item, index) => (
                  <li key={index}>
                    <a className={`icon-btn btn-${item.class} button-effect btn-sm`} href={item.url} target="_new"><i className={`fa fa-${item.icon}`} /></a>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
          <FooterMenu />
        </Row>
      </Container>
      {!landing && (
        <div className="footer-back-block">
          <Image className="img-fluid inner1" src={dynamicImage("landing/footer/2.png")} alt="footer-back-img" />
          <Image className="img-fluid inner2" src={dynamicImage("landing/footer/2.png")} alt="footer-back-img" />
        </div>
      )}
      <Container className="copyright-footer">
        <Row className="copyright">
          <Col md="6" sm="12"><p>© 2024 Chatzy. All Right Reserved</p></Col>
          <Col md="6" sm="12" className="links_horizontal"><p>Made with <span>♥ </span>By Template Pixelstrap</p></Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Footer;
